<template>
  <div class="form-group">
    <div class="form-item_mn">
      <label v-if="label" class="label">{{label}}</label>
      <slot></slot>
    </div>
    <div
      :class="['invalid-feedback',label? 'label-invalid-feedback':'']"
      v-if="errorMsg"
    >{{errorMsg}}</div>
  </div>
</template>
<script>
export default {
  name: "form-item",
  props: {
    label: String,
    prop: String
  },
  data() {
    return {
      errorMsg: ""
    };
  },
  methods: {
    showError(msg) {
      this.errorMsg = msg;
    }
  }
};
</script>
<style lang="scss" scoped>
.invalid-feedback {
  position: absolute;
  // bottom: 85%;
  left: 1.5625rem;
  top: -0.575rem;
  background-color: #fff;
  padding: 0 0.5625rem;
  margin-bottom: 0;
  color: #c53131;
  font-size: 0.6875rem;
  &.label-invalid-feedback {
    top: 1.55rem;
  }
}
.form-group {
  .label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0.75rem;
  }
  .eye-icon__container,
  .pic-code,
  .send-code {
    position: absolute;
    right: 1.25rem;
    transform: translateY(-50%);
    top: 50%;
  }
  .pic-code {
    width: 5rem;
    // height: 100%;
  }
  .send-code {
    color: #000;
    text-decoration: underline;
    cursor: pointer;
    &[disabled] { color: #cacaca; cursor: not-allowed; text-decoration: none; }
  }
}
</style>
